import React from 'react';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { Modal, Stack, Card, CardContent, Typography, Button } from '@mui/material';
import { deleteOrderAction } from '../../../../services/request';
import { deleteOrder } from '../../../../services/redux-actions';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const ConfirmDeleteModal = ({ order, open, handleClose, removeOrderFromOrders }) => {
  const dispatch = useDispatch();
  const { loading, mutate } = useMutation(deleteOrderAction);

  const handleSubmit = async () => {
    const { error, payload } = await mutate(order.id);
    if (!error) {
      handleClose();
      dispatch(deleteOrder(order.id));
      removeOrderFromOrders(order.id);
    } else {
      toast.error('Nie udało się usunąć zamówienia');
    }
  };

  return (
    <Modal open={open} onClose={handleClose} >
      <Card sx={{ ...style, width: '25vw', height: '25vh' }}>
        <CardContent sx={{ height: '100%' }}>
          <Stack direction="column" sx={{ height: '100%' }}>
            <Typography variant="h4" textAlign="center">
              Czy na pewno chcesz usunąć zamówienie {order.identifier} ?
            </Typography>
            <Stack direction="row" justifyContent="space-around" alignItems="end" flexGrow={1}>
              <Button variant="contained" onClick={handleClose}>Nie</Button>
              <Button color="error" variant="contained" onClick={handleSubmit} disabled={loading}>Tak</Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Modal>
  );
};


export default ConfirmDeleteModal;
